import { useState } from 'react'
import styled from 'styled-components'
import { Card, CardHeader } from '../../../../styled/cards'
import { FiCheckCircle, FiXCircle } from 'react-icons/fi'
import { useTranslation } from '../../../../../hooks'

// TODO reuse modal styling
const ModalContainer = styled.div`
    height: 100vh;
    width: 100%;
    background: rgba(0, 0, 0, 0.3);

    position: fixed;
    top: 0;
    left: 0;
    z-index: 500;
`

const Modal = styled.div`
    min-height: 40rem;
    width: 54rem;

    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 501;

    @media screen and (max-width: 480px) {
        width: 35rem;
    }
`

const CancelButton = styled.p`
    font-size: 1.4rem;
    color: ${({ theme }) => `${theme.primary}50`};
    padding: 1rem;
    cursor: pointer;
`

const ButtonContainer = styled.div`
    padding-top: 2rem;
    padding-bottom: 1rem;
    margin: 0 1.4rem;
    display: flex;
    gap: 1rem;
    border-bottom: 1px solid ${({ theme }) => theme.grey};
`

interface IsActiveProp {
    isActive: boolean
}

const Button = styled.div<IsActiveProp>`
    height: 4.7rem;
    width: 24.5rem;
    background: ${({ theme, isActive }) =>
        isActive ? theme.blue : `${theme.blue}10`};
    color: ${({ theme, isActive }) => (isActive ? theme.white : theme.blue)};
    border-radius: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.6rem;
    cursor: pointer;
`

const ButtonRed = styled(Button)<IsActiveProp>`
    background: ${({ theme, isActive }) =>
        isActive ? theme.red : `${theme.red}10`};
    color: ${({ theme, isActive }) => (isActive ? theme.white : theme.red)};
`

const CheckIcon = styled(FiCheckCircle)<IsActiveProp>`
    font-size: 1.9rem;
    color: ${({ theme, isActive }) => (isActive ? theme.white : theme.blue)};
    margin-right: 0.5rem;
`
const CloseIcon = styled(FiXCircle)<IsActiveProp>`
    font-size: 1.9rem;
    color: ${({ theme, isActive }) => (isActive ? theme.white : theme.red)};
    margin-right: 0.5rem;
`

const AddCommentForm = styled.form`
    width: 100%;
    padding: 0 1.4rem;
    padding-top: 4rem;
    padding-bottom: 3rem;
`

const AddCommentHeading = styled.div`
    font-size: 1.2rem;
    font-weight: 600;
    color: ${({ theme }) => theme.black};
    padding-bottom: 1rem;
`

const AddCommentTextarea = styled.textarea`
    height: 12rem;
    width: 100%;
    border: 1px solid ${({ theme }) => theme.grey};
    resize: none;
    margin-bottom: 2rem;
    padding: 1rem;
`

const ButtonFullWidth = styled.div<IsActiveProp>`
    height: 5rem;
    width: 100%;
    background: ${({ theme, isActive }) =>
        isActive ? theme.blue : `${theme.primary}05`};
    color: ${({ theme, isActive }) =>
        isActive ? theme.white : `${theme.primary}50`};
    border-radius: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.6rem;
    cursor: pointer;
`

interface CloseCaseModalProps {
    handleCloseCase: (status: string, comment: string) => void
    closeModal: () => void
}

const CloseCaseModal: React.FC<CloseCaseModalProps> = ({
    handleCloseCase,
    closeModal,
}) => {
    const translation = useTranslation()

    const [activeSolveState, setActiveSolveState] = useState<null | string>(
        null
    )

    const [comment, setComment] = useState('')

    const handleOnSubmit = () => {
        if (activeSolveState !== null) {
            handleCloseCase(activeSolveState, comment)
        }
    }

    return (
        <ModalContainer>
            <Modal>
                <Card>
                    <CardHeader>
                        {translation.caseworkerOpenReport.closeCase}
                        <CancelButton onClick={closeModal}>
                            {translation.reusable.cancel}
                        </CancelButton>
                    </CardHeader>
                    <ButtonContainer>
                        <Button
                            isActive={activeSolveState === 'solved'}
                            onClick={() => setActiveSolveState('solved')}
                        >
                            <CheckIcon
                                isActive={activeSolveState === 'solved'}
                            />
                            {translation.caseworkerOpenReport.solved}
                        </Button>
                        <ButtonRed
                            isActive={activeSolveState === 'rejected'}
                            onClick={() => setActiveSolveState('rejected')}
                        >
                            <CloseIcon
                                isActive={activeSolveState === 'rejected'}
                            />
                            {translation.caseworkerOpenReport.denied}
                        </ButtonRed>
                    </ButtonContainer>

                    <AddCommentForm>
                        <AddCommentHeading>
                            {translation.caseworkerOpenReport.addComment}
                        </AddCommentHeading>
                        <AddCommentTextarea
                            onChange={(e) => setComment(e.target.value)}
                        ></AddCommentTextarea>
                        <ButtonFullWidth
                            isActive={activeSolveState !== null}
                            onClick={handleOnSubmit}
                        >
                            {translation.caseworkerOpenReport.saveThis}
                        </ButtonFullWidth>
                    </AddCommentForm>
                </Card>
            </Modal>
        </ModalContainer>
    )
}

export default CloseCaseModal
